import { CLIENTS_CUSTOMER, CLIENTS_CUSTOMER_SUCCESS, CLIENTS_CUSTOMER_ERROR, CLIENTS_CUSTOMER_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientsCustomer = (state = initialState, action) => {
  switch (action.type) {
    case CLIENTS_CUSTOMER:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENTS_CUSTOMER_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENTS_CUSTOMER_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENTS_CUSTOMER_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientsCustomer;
